import React from 'react'

const AdminStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Jobs',
      value: stats.totalJobs,
      icon: 'fas fa-briefcase',
      color: 'blue'
    },
    {
      title: 'Active Jobs',
      value: stats.activeJobs,
      icon: 'fas fa-check-circle',
      color: 'green'
    },
    {
      title: 'Inactive Jobs',
      value: stats.inactiveJobs,
      icon: 'fas fa-pause-circle',
      color: 'orange'
    },
  ]

  const getColorClass = (color) => {
    const colors = {
      blue: 'stat-blue',
      green: 'stat-green',
      orange: 'stat-orange'
    }
    return colors[color] || 'stat-blue'
  }

  return (
    <div className="admin-stats">
      <div className="stats-header">
        <h2>Statistics Dashboard</h2>
        <p>Overview of your recruitment activity</p>
      </div>

      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <div key={index} className={`stat-card ${getColorClass(stat.color)}`}>
            <div className="stat-icon">
              <i className={stat.icon}></i>
            </div>
            <div className="stat-content">
              <h3>{stat.value}</h3>
              <p>{stat.title}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="charts-section">
        <div className="chart-card">
          <h3>Recent Activity</h3>
          <p>Charts and analytics coming soon...</p>
        </div>
      </div>
    </div>
  )
}

export default AdminStats
